var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcMobilite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#231F20;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45,50.5H15c-4.1,0-7.5-3.4-7.5-7.5V10.2c0-4.1,3.4-7.5,7.5-7.5h30c4.1,0,7.5,3.4,7.5,7.5V43 C52.5,47.1,49.2,50.5,45,50.5z M15,6.8c-1.9,0-3.4,1.5-3.4,3.4V43c0,1.9,1.5,3.4,3.4,3.4h30c1.9,0,3.4-1.5,3.4-3.4V10.2 c0-1.9-1.5-3.4-3.4-3.4H15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.4,42.3h-2.7c-1.1,0-2-0.9-2-2s0.9-2,2-2h2.7c1.1,0,2,0.9,2,2S21.6,42.3,20.4,42.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.3,42.3h-2.7c-1.1,0-2-0.9-2-2s0.9-2,2-2h2.7c1.1,0,2,0.9,2,2S43.4,42.3,42.3,42.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.5,34.1H9.5c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2h40.9c1.1,0,2,0.9,2,2C52.5,33.2,51.6,34.1,50.5,34.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.3,28.6c-1.1,0-2-0.9-2-2v-8.2c0-0.4-0.3-0.7-0.7-0.7H5.4c-0.4,0-0.7,0.3-0.7,0.7v8.2c0,1.1-0.9,2-2,2 s-2-0.9-2-2v-8.2c0-2.6,2.1-4.8,4.8-4.8h49.1c2.6,0,4.8,2.1,4.8,4.8v8.2C59.3,27.7,58.4,28.6,57.3,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17,57.3h-2.7c-2.6,0-4.8-2.1-4.8-4.8v-5.3c0-1.1,0.9-2,2-2s2,0.9,2,2v5.3c0,0.4,0.3,0.7,0.7,0.7H17 c0.4,0,0.7-0.3,0.7-0.7v-4.1c0-1.1,0.9-2,2-2s2,0.9,2,2v4.1C21.8,55.2,19.6,57.3,17,57.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.7,57.3H43c-2.6,0-4.8-2.1-4.8-4.8v-4.1c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2v4.1c0,0.4,0.3,0.7,0.7,0.7h2.7 c0.4,0,0.7-0.3,0.7-0.7v-5.3c0-1.1,0.9-2,2-2s2,0.9,2,2v5.3C50.5,55.2,48.4,57.3,45.7,57.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMobilite);
export default __webpack_public_path__ + "static/media/ic_mobilite.38cceb9f3960d47c7162c5ffef9d409b.svg";
export { ForwardRef as ReactComponent };